module.exports = __webpack_public_path__ + "static/welcome-to-chinatown-logo-bw-3441bff02322a14c7f6202f212398f64.png";